<template>
  <button class="ovalButton">
    <slot></slot>
  </button>
</template>

<script>
export default {}
</script>

<style lang='scss'>
.ovalButton {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
  box-sizing: border-box;
  height: 1.875rem;
  border-radius: 0.9375rem;
  border: 0.125rem solid;
  margin-top: 0.3125rem;
  margin-bottom: 0.3125rem;
  display: inline-block;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
</style>



// WEBPACK FOOTER //
// OvalButton.vue?1553f223